document.addEventListener('alpine:init', () => {
    Alpine.data('countdown', () => ({
        start: '2022/10/24 00:00:00',
        countdown: {},
        init() {
            this.updateTimer()

            setInterval(() => {
                this.updateTimer()
            })
        },
        updateTimer() {
            let seconds = Math.abs((Date.now() - (new Date(this.start)).getTime()) / 1000)

            const days = seconds / (60 * 60 * 24)
            seconds %= 60 * 60 * 24

            const hours = seconds / (60 * 60)
            seconds %= 60 * 60

            const minutes = seconds / 60
            seconds %= 60

            this.countdown = {
                days: Math.floor(days).toString().padStart(2, '0'),
                hrs: Math.floor(hours).toString().padStart(2, '0'),
                mins: Math.floor(minutes).toString().padStart(2, '0'),
                secs: Math.floor(seconds).toString().padStart(2, '0'),
            }
        },
    }))
})
